import { module } from 'modujs';
var Draggable = require ('Draggable');


export default class extends module {
    constructor(m) {
        super(m);

        console.info('+++');
    }
    init() {
        this.onResizeBind = this.onResize.bind( this );
        window.addEventListener( 'resize', this.onResizeBind );
        this.scroll = this.modules.Scroll.main.lenis;

        this.thumb = this.$( 'thumb' )[0];
        this.onResize();
        this.el.addEventListener( 'mousedown', () => this.el.classList.add( 'hover' ) );
        this.el.addEventListener( 'mouseup', () => this.el.classList.remove( 'hover' ) );
        this.el.addEventListener( 'click', e => {
            if( e.target === e.currentTarget ){
                this.setY( e.clientY );
            }
        });

        this.el.addEventListener( 'mousewheel', e => {
            this.modules.Scroll.main.el.dispatchEvent(new WheelEvent('wheel', e ));
        });

        this.draggable = new Draggable ( this.thumb , {
            setPosition: false,
            limit : ( x, y, x0, y0 ) => {
                if( y > this.limitY ){
                    y = this.limitY;
                } else if( y < 0 ){
                    y = 0;
                }
                return { x: 0, y : y }
            },
            onDrag : (args,x,y) => {
                this.setY(y);

            }
        });

        this.scroll.on("scroll", ( args ) => {
            this.draggable.set( 0, args.progress * this.limitY );
        });

    }
    setY( y ){
        this.scroll.scrollTo( this.scroll.dimensions.scrollHeight * y / this.limitY );
    }
    onResize(){
        this.thumbHeight = this.thumb.getBoundingClientRect().height;
        this.limitY = this.scroll.dimensions.height - this.thumbHeight;
    }
    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }
}
